import { apiCall, ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent/types'
import { GenericOrderBy } from '../../../components/_EOS/Table/types'
import { Asn } from '../../../interfaces/Asn/Asn'

export const getAsns = (filters: Filter[], page: number, pageSize: number, supplierId?: number, orderBy?: GenericOrderBy<Asn>) => {
  const queryParams = new URLSearchParams()
  queryParams.append('pageIndex', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  if (supplierId) {
    queryParams.append('supplierId', supplierId.toString())
  }

  // Procesar filtros
  filters.forEach(filter => {
    if (filter.key === 'createdDateRange') {
      // Parsear el JSON del componente custom y agregar las fechas como params separados
      try {
        const dateRange = JSON.parse(filter.value)
        if (dateRange.initialCreatedDate) {
          queryParams.append('initialCreatedDate', dateRange.initialCreatedDate)
        }
        if (dateRange.finalCreatedDate) {
          queryParams.append('finalCreatedDate', dateRange.finalCreatedDate)
        }
      } catch {
        // Si no es JSON válido, ignorar
      }
      return
    }

    if (filter.key === 'initialDateFilter') {
      queryParams.append('initialDate', filter.value)
    } else if (filter.key === 'finalDateFilter') {
      queryParams.append('finalDate', filter.value)
    } else {
      queryParams.append(filter.key, filter.value)
    }
  })

  // Agregar parámetros de ordenamiento
  if (orderBy) {
    const sorters = {
      datafield: orderBy.field.toString(),
      sortOrder: orderBy.direction
    }
    queryParams.append('sorters', JSON.stringify(sorters))
  }

  return apiCall('GET', `${ApiConfig.AsnApi}?${queryParams.toString()}`)
}

export const deleteAsn = (asnId: number) => {
  const queryParams = new URLSearchParams()
  queryParams.append('asnId', asnId.toString())

  return apiCall('DELETE', `${ApiConfig.AsnApi}/SoftDelete?${queryParams.toString()}`)
}

export const getAsnState = (asnId: number) => {
  return apiCall('GET', `${ApiConfig.AsnApi}/${asnId}`)
}

export const receiveAsn = (asnId: number, userId: number, isReserve?: boolean, comment?: string) => {
  const dto = {
    asnId: asnId,
    userId: userId,
    isReserve: isReserve || false,
    comment: comment || ''
  }

  return apiCall('PUT', `${ApiConfig.InboundApi}/ReceiveAsn`, dto)
}
